<template>
	<div class="pe-overlay">
		<div class="backdrop" :class="{ show: show }" @click="cancel"></div>
		<div class="modal pe-prompt" :class="{ show: show }" role="dialog" aria-modal="true" :aria-label="title" @keydown.esc.stop="cancel">
			<div class="modal-head"><b>{{ title }}</b><button class="navbtn close" aria-label="Close" @click="cancel"><i class="fa-solid fa-xmark"></i></button></div>
			<div class="save-body">
				<p v-if="text" class="save-hint">{{ text }}</p>
				<div v-for="f in fields" :key="f.key" class="ff">
					<label v-if="f.label">{{ f.label }}</label>
					<textarea v-if="f.type === 'textarea'" :ref="'f-' + f.key" rows="3" v-model="values[f.key]" :placeholder="f.placeholder || ''"></textarea>
					<select v-else-if="f.type === 'select'" :ref="'f-' + f.key" v-model="values[f.key]"><option v-for="o in f.options" :key="o.value" :value="o.value">{{ o.label }}</option></select>
					<input v-else :ref="'f-' + f.key" type="text" v-model="values[f.key]" :placeholder="f.placeholder || ''" />
				</div>
				<p v-if="error" class="pe-prompt-error">{{ error }}</p>
			</div>
			<div class="modal-foot"><span></span><div class="row"><button class="pill" @click="cancel">{{ cancelLabel }}</button><button ref="ok" class="btn-primary" :class="{ danger: danger }" @click="confirm">{{ confirmLabel }}</button></div></div>
		</div>
	</div>
</template>

<script>
/**
 * One modal for every question the pricing screens ask: a confirmation, one or more inputs. open(opts) returns a promise
 * that resolves with the values (one value when there is one field, true for a plain confirmation) or null when cancelled.
 * opts: { title, text, fields: [{ key, label, type: text|textarea|select, options, value, placeholder, required }], input (shorthand: a type),
 *         label, value, placeholder, confirm, cancel, danger }
 */
export default {
	name: 'PePrompt',
	data() { return { show: false, title: '', text: '', fields: [], values: {}, confirmLabel: 'OK', cancelLabel: 'Cancel', danger: false, error: '', resolve: null } },
	mounted() { if (this.$el.parentNode !== document.body) document.body.appendChild(this.$el) },
	beforeDestroy() { if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el) },
	methods: {
		open(opts) {
			if (this.resolve) this.resolve(null)
			const fields = opts.fields || (opts.input ? [{ key: 'value', label: opts.label || '', type: opts.input, value: opts.value, placeholder: opts.placeholder, options: opts.options, required: opts.required !== false }] : [])
			this.title = opts.title || ''; this.text = opts.text || ''; this.fields = fields
			this.values = Object.fromEntries(fields.map(f => [f.key, f.value === undefined || f.value === null ? (f.type === 'select' && f.options && f.options.length ? f.options[0].value : '') : f.value]))
			this.confirmLabel = opts.confirm || 'OK'; this.cancelLabel = opts.cancel || 'Cancel'; this.danger = !!opts.danger; this.error = ''
			this.show = true
			this.$nextTick(() => { const first = fields[0] && this.$refs['f-' + fields[0].key]; const el = first && first[0] ? first[0] : (first || this.$refs.ok); if (el && el.focus) el.focus() })
			return new Promise(resolve => { this.resolve = resolve })
		},
		confirm() {
			for (const f of this.fields) {
				const v = this.values[f.key]
				if (f.required !== false && (v === '' || v === null || v === undefined || (typeof v === 'string' && !v.trim()))) { this.error = 'Fill this in first.'; return }
			}
			const out = this.fields.length === 0 ? true : (this.fields.length === 1 ? this.values[this.fields[0].key] : Object.assign({}, this.values))
			this.done(typeof out === 'string' ? out.trim() : out)
		},
		cancel() { this.done(null) },
		done(v) { this.show = false; const r = this.resolve; this.resolve = null; if (r) r(v) },
	},
}
</script>
